import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2, Clock, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { zl } from "@/lib/shop";
import ShopLayout from "./ShopLayout";
import { Button } from "@/components/ui/button";

export default function ShopPaymentResult() {
  const [sp] = useSearchParams();
  const ext = sp.get("order");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!ext) { setLoading(false); return; }
    let active = true;
    const poll = () => api.get(`/shop/orders/${ext}`).then((r) => {
      if (!active) return;
      setData(r.data); setLoading(false);
      if (r.data.payment_status !== "COMPLETED" && r.data.payment_status !== "CANCELED" && tries < 10) {
        setTimeout(() => setTries((t) => t + 1), 2500);
      }
    }).catch(() => { if (active) setLoading(false); });
    poll();
    return () => { active = false; };
  }, [ext, tries]);

  const paid = data?.payment_status === "COMPLETED";
  const canceled = data?.payment_status === "CANCELED";

  return (
    <ShopLayout>
      <div className="mx-auto max-w-xl px-4 py-20 text-center">
        {loading ? <Loader2 className="mx-auto h-10 w-10 animate-spin text-amber-400" />
        : !data ? <p className="text-neutral-400">Nie znaleziono zamówienia.</p>
        : (
          <div data-testid="payment-result">
            {paid ? <CheckCircle2 className="mx-auto h-16 w-16 text-emerald-400" />
              : canceled ? <XCircle className="mx-auto h-16 w-16 text-rose-400" />
              : <Clock className="mx-auto h-16 w-16 text-amber-400" />}
            <h1 className="mt-5 font-display text-3xl font-extrabold uppercase tracking-tight">
              {paid ? "Dziękujemy za zamówienie!" : canceled ? "Płatność anulowana" : "Oczekiwanie na płatność"}
            </h1>
            <p className="mt-3 text-neutral-400">
              Numer zamówienia: <span className="font-bold text-neutral-200" data-testid="result-number">{data.number}</span><br />
              Kwota: <span className="font-bold text-neutral-200">{zl(data.total_grosz)}</span>
            </p>
            <p className="mt-3 text-sm text-neutral-500">
              {paid ? `Potwierdzenie wyślemy na ${data.buyer_email}. Zajmiemy się realizacją zamówienia.`
                : canceled ? "Twoja płatność została anulowana. Możesz spróbować ponownie."
                : "Jeśli płatność została wykonana, status zaktualizuje się automatycznie w ciągu chwili."}
            </p>
            <Link to="/sklep"><Button className="mt-8 bg-amber-400 text-[#0D1117] hover:bg-amber-300 font-bold">Wróć do sklepu</Button></Link>
          </div>
        )}
      </div>
    </ShopLayout>
  );
}
